import React, { Component } from "react";
import "../../components/css/singUp.css";
import Register from "../../components/Register";
class SignUp extends Component {
  render() {
    return (
      <div>
        <br />
        <br />

        <Register />
      </div>
    );
  }
}
export default SignUp;
